/**
 * The available languages should be fetched from the backend
 * but this endpoint is not available yet.
 */
export const TEMPORAL_AVAILABLE_LANGUAGES = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
  {
    label: 'Chinese',
    value: 'zh',
  },
  {
    label: 'Russian',
    value: 'ru',
  },
  {
    label: 'Dutch',
    value: 'nl',
  },
  {
    label: 'Italian',
    value: 'it',
  },
  {
    label: 'Portuguese',
    value: 'pt',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
]
